var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-radio-group',{attrs:{"value":_vm.value,"disabled":_vm.isReadSurvey || _vm.options.readonly},on:{"change":_vm.onUpdateValue}},_vm._l((_vm.choices),function(choice,index){return _c('v-radio',{key:`${_vm.questionId}-${index}`,attrs:{"label":choice.label,"value":choice.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }